
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industrial-design/countries",
      function () {
        return require("private-next-pages/industrial-design/countries/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industrial-design/countries"])
      });
    }
  